var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{class:_vm.spanClass.join(' '),style:(("" + _vm.color + _vm.fontSize))},[_vm._v(" "+_vm._s(('text' in _vm.data)? _vm.data.text : '')+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }